'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useFirstMount", {
    enumerable: true,
    get: function() {
        return useFirstMount;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useFirstMount() {
    const isFirst = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirst.current) {
            isFirst.current = false;
        }
    }, []);
    return isFirst.current;
}
